export enum SortOptionEnum {
  PRICE = 'price',
  PRICEANDSTOCKSTATUS = 'price_in_stock',
  RECOMMENDED = 'recommended',
}

export type SortOption =
  | SortOptionEnum.PRICE
  | SortOptionEnum.RECOMMENDED
  | SortOptionEnum.PRICEANDSTOCKSTATUS;
